import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import React from 'react';
import DocTypeWrapper from './DocTypeWrapper';
import { InlineHighlight } from './InlineTypeHighlight';
import typeExpression from './utils/jsDocTypeExpression';
export var isFunctionDef = function isFunctionDef(definition, recursive) {
  if (recursive === void 0) {
    recursive = true;
  }

  return definition.params && definition.params.length > 0 || definition.returns && definition.returns.length > 0 || recursive && definition.type && definition.type.typeDef && isFunctionDef(definition.type.typeDef, false);
};
export default function JsDocFunctionSignature(_ref) {
  var block = _ref.block,
      definition = _ref.definition,
      ignoreParams = _ref.ignoreParams;
  var params = definition.params ? definition.params.filter(function (param) {
    return !ignoreParams.includes(param.name);
  }).map(function (param) {
    var type = param.type && (param.optional ? '?' : '') + ": " + typeExpression(param.type);
    return "" + param.name + (type || '');
  }) : [];
  var returns = definition.returns && definition.returns.length ? typeExpression(definition.returns[0].type) : 'void';
  return /*#__PURE__*/React.createElement(DocTypeWrapper, {
    block: block
  }, /*#__PURE__*/React.createElement(InlineHighlight, {
    code: "(" + params.join(', ') + ") => " + returns
  }));
}